import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Form, Select, Segment, Input} from 'semantic-ui-react';
import {parseStatus, parseCarModels, parseParts, parseTasks} from '../../utils';
import {WARRANTIES_TYPES} from '../../constants';
import {parseDealers} from '../../../common/util/options';
import {dateFormatPicker} from '../../../common/constants/datesFormat';
import {parseCampaignOptions} from '../../../campaign/utils';
import {Actions} from '../../../common/actions';

const {getPartCarModels, getWarrantyJobBySearch, getWarrantyPartsBySearch} =
  Actions;

const SearchFormMany = ({
  handleChangeDate,
  campaignOptions,
  warrantyStatus,
  dealersOptions,
  handleChange,
  campaignNo,
  initDate,
  endDate,
  typeTwc,
  status,
  dealer,
  katashiki,
  invoice,
  account,
  tasks,
  OFP,
  reportType,
}) => {
  const dealers = parseDealers(dealersOptions);
  const campaigns = parseCampaignOptions(campaignOptions);
  const {partsList, loadingParts, jobsList, loadingJobs} = useSelector(
    (state) => state.warrantiesCategories
  );
  const {partCarModels, loadingPartCarModels} = useSelector(
    (state) => state.partsMaster
  );
  const dispatch = useDispatch();
  const [originalTasks, setOriginalTasks] = useState([]);

  useEffect(() => {
    if (tasks.length && jobsList.length) {
      let allTasks = originalTasks.filter((task) => tasks.includes(task.id));
      allTasks = allTasks.concat(jobsList);
      setOriginalTasks(allTasks);
    } else if (!tasks.length) {
      setOriginalTasks(jobsList);
    }
  }, [jobsList]);

  const handleKatashikiSearch = (e, {searchQuery}) => {
    if (searchQuery.length > 2) {
      const filter = searchQuery.toUpperCase();
      dispatch(getPartCarModels({filter}));
    }
  };

  const handleTasksSearch = (e, {searchQuery}) => {
    if (searchQuery.length > 2) {
      const search = searchQuery.toUpperCase();
      dispatch(getWarrantyJobBySearch({search}));
    }
  };

  const handleOFPSearch = (e, {searchQuery}) => {
    if (searchQuery.length > 3) {
      const search = searchQuery.toUpperCase();
      dispatch(getWarrantyPartsBySearch({search}));
    }
  };

  return (
    <React.Fragment>
      <Segment vertical>
        <label className='label-group'>Seleccione tipo de reporte:</label>
        <Form.Group widths='4'>
          <Form.Radio
            label='Detallado TWC'
            name='reportType'
            value='TWC'
            checked={reportType === 'TWC'}
            onChange={handleChange}
          />
          <Form.Radio
            label='Concesionario'
            name='reportType'
            value='dealer'
            checked={reportType === 'dealer'}
            onChange={handleChange}
          />
        </Form.Group>
      </Segment>
      <Segment basic>
        <label className='label-group'>Parámetros de garantías:</label>
        <Form.Group widths='4'>
          <Form.Input fluid label='Fecha de inicial'>
            <DatePicker
              placeholderText='Fecha de inicial'
              className='tcc-datepicker'
              showYearDropdown
              required={!invoice}
              selected={initDate}
              dateFormat={dateFormatPicker}
              onChange={(value) => handleChangeDate('initDate', value)}
              locale='es'
            />
          </Form.Input>
          <Form.Input fluid label='Fecha de final'>
            <DatePicker
              placeholderText='Fecha de final'
              className='tcc-datepicker'
              showYearDropdown
              required={!invoice}
              selected={endDate}
              dateFormat={dateFormatPicker}
              minDate={initDate}
              onChange={(value) => handleChangeDate('endDate', value)}
              locale='es'
            />
          </Form.Input>
          <Form.Field
            control={Select}
            options={parseStatus(warrantyStatus)}
            label='Estado'
            placeholder='Estado'
            name='status'
            value={status}
            onChange={handleChange}
          />
          <Form.Field
            control={Select}
            options={WARRANTIES_TYPES}
            label='Tipo TWC'
            placeholder='Tipo'
            name='typeTwc'
            value={typeTwc}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group widths='4'>
          <Form.Field
            search
            value={campaignNo}
            control={Select}
            options={campaigns}
            label='Campaña'
            name='campaignNo'
            placeholder='Seleccione Campaña'
            onChange={handleChange}
          />
          <Form.Field
            control={Select}
            search
            multiple
            options={dealers}
            label='Concesionario'
            placeholder='Seleccione Concesionario'
            name='dealer'
            value={dealer}
            onChange={handleChange}
          />
          <Form.Field
            control={Input}
            label='Cuenta de cobro'
            placeholder='Cuenta de cobro'
            name='account'
            value={account}
            onChange={handleChange}
          />
          <Form.Field
            control={Input}
            label='No de Factura'
            placeholder='No de Factura'
            name='invoice'
            value={invoice}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group widths='4'>
          <Form.Field
            control={Select}
            clearable
            options={parseCarModels(partCarModels)}
            search
            label='Katashiki'
            placeholder='Seleccione katashiki'
            name='katashiki'
            loading={loadingPartCarModels}
            value={katashiki}
            onChange={handleChange}
            onSearchChange={handleKatashikiSearch}
          />
          <Form.Field
            value={OFP}
            control={Select}
            options={parseParts(partsList)}
            search
            clearable
            label='Número de Parte Principal'
            placeholder='Seleccione número de parte'
            name='OFP'
            loading={loadingParts}
            onChange={handleChange}
            onSearchChange={handleOFPSearch}
          />
          <Form.Field
            value={tasks}
            multiple
            search
            options={parseTasks(originalTasks)}
            control={Select}
            label='Número de Tarea'
            placeholder='Seleccione número de tarea'
            name='tasks'
            loading={loadingJobs}
            onChange={handleChange}
            onSearchChange={handleTasksSearch}
          />
        </Form.Group>
      </Segment>
    </React.Fragment>
  );
};

export default SearchFormMany;
